// extracted by mini-css-extract-plugin
export default {"template":"video_template__YO9VT","block":"video_block__4u1KP","frame":"video_frame__+6vJS"};